__turbopack_context__.v({
  "axis": "NetBuySellBar-module-scss-module___YZrNG__axis",
  "axisRow": "NetBuySellBar-module-scss-module___YZrNG__axisRow",
  "axisScale": "NetBuySellBar-module-scss-module___YZrNG__axisScale",
  "axisSpacer": "NetBuySellBar-module-scss-module___YZrNG__axisSpacer",
  "axisTick": "NetBuySellBar-module-scss-module___YZrNG__axisTick",
  "axisZero": "NetBuySellBar-module-scss-module___YZrNG__axisZero",
  "barArea": "NetBuySellBar-module-scss-module___YZrNG__barArea",
  "barBuy": "NetBuySellBar-module-scss-module___YZrNG__barBuy",
  "barSell": "NetBuySellBar-module-scss-module___YZrNG__barSell",
  "body": "NetBuySellBar-module-scss-module___YZrNG__body",
  "card": "NetBuySellBar-module-scss-module___YZrNG__card",
  "empty": "NetBuySellBar-module-scss-module___YZrNG__empty",
  "header": "NetBuySellBar-module-scss-module___YZrNG__header",
  "headerMeta": "NetBuySellBar-module-scss-module___YZrNG__headerMeta",
  "headerText": "NetBuySellBar-module-scss-module___YZrNG__headerText",
  "loading": "NetBuySellBar-module-scss-module___YZrNG__loading",
  "netBuySellPulse": "NetBuySellBar-module-scss-module___YZrNG__netBuySellPulse",
  "row": "NetBuySellBar-module-scss-module___YZrNG__row",
  "rows": "NetBuySellBar-module-scss-module___YZrNG__rows",
  "select": "NetBuySellBar-module-scss-module___YZrNG__select",
  "skeleton": "NetBuySellBar-module-scss-module___YZrNG__skeleton",
  "skeletonBar": "NetBuySellBar-module-scss-module___YZrNG__skeletonBar",
  "skeletonRow": "NetBuySellBar-module-scss-module___YZrNG__skeletonRow",
  "skeletonSubtitle": "NetBuySellBar-module-scss-module___YZrNG__skeletonSubtitle",
  "skeletonTicker": "NetBuySellBar-module-scss-module___YZrNG__skeletonTicker",
  "skeletonTitle": "NetBuySellBar-module-scss-module___YZrNG__skeletonTitle",
  "skeletonValue": "NetBuySellBar-module-scss-module___YZrNG__skeletonValue",
  "subtitle": "NetBuySellBar-module-scss-module___YZrNG__subtitle",
  "tick": "NetBuySellBar-module-scss-module___YZrNG__tick",
  "ticker": "NetBuySellBar-module-scss-module___YZrNG__ticker",
  "tickerLink": "NetBuySellBar-module-scss-module___YZrNG__tickerLink",
  "tickerName": "NetBuySellBar-module-scss-module___YZrNG__tickerName",
  "tickerSymbol": "NetBuySellBar-module-scss-module___YZrNG__tickerSymbol",
  "title": "NetBuySellBar-module-scss-module___YZrNG__title",
  "total": "NetBuySellBar-module-scss-module___YZrNG__total",
  "totalDivider": "NetBuySellBar-module-scss-module___YZrNG__totalDivider",
  "totalLabel": "NetBuySellBar-module-scss-module___YZrNG__totalLabel",
  "totalNeg": "NetBuySellBar-module-scss-module___YZrNG__totalNeg",
  "totalPos": "NetBuySellBar-module-scss-module___YZrNG__totalPos",
  "totals": "NetBuySellBar-module-scss-module___YZrNG__totals",
  "track": "NetBuySellBar-module-scss-module___YZrNG__track",
  "valueNeg": "NetBuySellBar-module-scss-module___YZrNG__valueNeg",
  "valuePos": "NetBuySellBar-module-scss-module___YZrNG__valuePos",
  "valueSep": "NetBuySellBar-module-scss-module___YZrNG__valueSep",
  "valueSpacer": "NetBuySellBar-module-scss-module___YZrNG__valueSpacer",
  "values": "NetBuySellBar-module-scss-module___YZrNG__values",
});
